<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">校外实训基地列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="基地名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入基地名称"></el-input>
        </el-form-item>
        <el-form-item label="院系">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell1" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="formInline.structure_1" placeholder="请选择院系" @focus="dialogOpen1" @clear="handeleClear1"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="协议签订时间">
          <el-date-picker v-model="formInline.sign_agreement_date" clearable value-format="yyyy-MM-dd" type="date"
            placeholder="请选择协议签订时间"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd(() => $store.dispatch('getProvices'))">新增校外实训基地</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="importUrl" :params="params"
            btnTitle="导入数据"></Importt>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" min-width="160" label="名称">
        </custom-table-column>
        <!-- <custom-table-column fixed prop="is_reimburse" label="合作状态" width="80">
          <template slot-scope="scope">
            <span v-if="!scope.row.collaborate" style="color:var(--red);">不再合作 </span>
            <span v-else style="color:var(--ligtGreen);">合作</span>
          </template>
</custom-table-column> -->
        <custom-table-column prop="base_no" width="150" label="基地编号">
        </custom-table-column>
        <custom-table-column prop="cooperation_status" width="150" label="合作状态">
        </custom-table-column>
        <custom-table-column prop="structure_1" width="160" label="院系">
        </custom-table-column>
        <custom-table-column prop="major" width="160" label="专业">
        </custom-table-column>
        <custom-table-column prop="dwzzjgdm" width="160" label="单位组织机构代码">
        </custom-table-column>
        <custom-table-column prop="region" width="200" label="所属区域">
          <template slot-scope="scope">
            {{ scope.row.province_name + scope.row.city_name + scope.row.district_name }}
          </template>
        </custom-table-column>
        <custom-table-column prop="address" min-width="220" label="地址">
        </custom-table-column>
        <custom-table-column prop="platform" width="180" label="主要设备平台或工艺">
        </custom-table-column>
        <custom-table-column prop="sign_agreement_date" label="协议签订时间" width="160">
        </custom-table-column>
        <custom-table-column prop="company_teacher" width="100" label="企业导师代表">
        </custom-table-column>
        <custom-table-column prop="post" width="160" label="主要岗位">
        </custom-table-column>
        <custom-table-column prop="people_num" width="120" label="实习生(人/年)">
        </custom-table-column>
        <custom-table-column prop="teacher" width="120" label="校内指导教师">
        </custom-table-column>
        <custom-table-column prop="teacher_number" width="150" label="校内指导教师工号">
        </custom-table-column>
        <custom-table-column prop="rely_unit_name" width="150" label="依托单位名称">
        </custom-table-column>
        <custom-table-column prop="rely_unit_type" width="150" label="依托单位性质">
        </custom-table-column>
        <custom-table-column prop="on_job_staff_num" width="150" label="在岗职工总数">
        </custom-table-column>
        <!-- <custom-table-column prop="region" width="150" label="所在区域">
        </custom-table-column> -->
        <custom-table-column prop="contact_name" width="150" label="基地联系人姓名">
        </custom-table-column>
        <custom-table-column prop="contact_phone" width="150" label="基地联系人电话">
        </custom-table-column>
        <custom-table-column prop="contact_email" width="150" label="基地联系人邮箱">
        </custom-table-column>
        <custom-table-column prop="establish_date" width="150" label="建立日期">
        </custom-table-column>
        <custom-table-column prop="industry_name" width="150" label="所属行业">
        </custom-table-column>
        <custom-table-column prop="industry_type" width="150" label="所属产业">
        </custom-table-column>
        <custom-table-column prop="cooperation_start_date" width="150" label="合作开始时间">
        </custom-table-column>
        <custom-table-column prop="cooperation_end_date" width="150" label="合作结束时间">
        </custom-table-column>
        <custom-table-column prop="agreement_status" width="150" label="合作协议签署状态">
        </custom-table-column>
        <custom-table-column prop="last_grade_level" width="150" label="最近一次评估等级">
        </custom-table-column>
        <custom-table-column prop="scoreList" width="500" label="打分情况">
          <template slot-scope="scope">
            <div v-if="scope.row.scoreList">
              <span v-for="item in scope.row.scoreList" :key="item.id">{{ item.item }}:{{ item.score_avg
              }}分;&nbsp;&nbsp;</span>
            </div>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.collaborate" @click="handleCollaborate(scope.row.id, 1)" type="text"
              size="small">设置合作</el-button>
            <el-button v-else @click="handleCollaborate(scope.row.id, 0)" type="text" size="small">设置不再合作</el-button>
            <el-button @click="handleScore(scope.row)" type="text" size="small">{{ $store.state.themeTitle
            }}室打分</el-button>
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="826px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="基地名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入基地名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地编号" prop="base_no">
          <el-input v-model="ruleForm.base_no" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="组织结构" prop="structure_1">
          <el-input v-model="selectName" placeholder="请选择院系" style="width:592px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="所在区域" prop="district_id">
          <div style="display: flex;justify-content: space-between;width:592px;">
            <el-select v-model="ruleForm.province_id" clearable style="width:33%;" placeholder="请选择省份"
              @change="handlePositionChange($event, 'city')">
              <el-option v-for="item in $store.state.provinces" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
            <el-select v-model="ruleForm.city_id" clearable style="width:33%;" placeholder="请选择城市"
              @change="handlePositionChange($event, 'district')">
              <el-option v-for="item in $store.state.citys" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
            <el-select v-model="ruleForm.district_id" clearable style="width:33%;" placeholder="请选择区县">
              <el-option v-for="item in $store.state.districts" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="ruleForm.address" placeholder="请输入" style="width:592px;"></el-input>
        </el-form-item>
        <el-form-item label="单位组织机构代码" prop="dwzzjgdm">
          <el-input v-model="ruleForm.dwzzjgdm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="主要设备平台或工艺" prop="platform">
          <el-input v-model="ruleForm.platform" placeholder="请输入主要设备平台或工艺" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="协议签订时间" prop="sign_agreement_date">
          <el-date-picker v-model="ruleForm.sign_agreement_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="请选择协议签订时间" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="企业导师代表" prop="company_teacher">
          <el-input v-model="ruleForm.company_teacher" placeholder="请输入企业导师代表" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="院系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请输入院系" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="主要岗位" prop="post">
          <el-input v-model="ruleForm.post" placeholder="请输入主要岗位" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实习生(人/年)" prop="people_num">
          <el-input v-model="ruleForm.people_num" placeholder="请输入实习生(人/年)" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="校内指导老师" prop="teacher_id">
          <el-select v-model="ruleForm.teacher_id" style="width:216px;" filterable :loading="loading" remote
            :remote-method="remoteMethod" @change="handleTeacherChange" placeholder="请输入名称搜索">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近一次评估等级" prop="last_grade_level">
          <el-select v-model="ruleForm.last_grade_level" style="width:216px;" placeholder="请选择最近一次评估等级 ">
            <el-option v-for="item in $store.state.levels" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="依托单位名称" prop="rely_unit_name">
          <el-input v-model="ruleForm.rely_unit_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="依托单位性质" prop="rely_unit_type">
          <el-select v-model="ruleForm.rely_unit_type" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.relys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在岗职工总数" prop="on_job_staff_num">
          <el-input v-model="ruleForm.on_job_staff_num" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地联系人姓名" prop="contact_name">
          <el-input v-model="ruleForm.contact_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地联系人电话" prop="contact_phone">
          <el-input v-model="ruleForm.contact_phone" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地联系人邮箱" prop="contact_email">
          <el-input v-model="ruleForm.contact_email" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="建立日期" prop="establish_date">
          <el-date-picker type="date" placeholder="选择建立日期" value-format="yyyy-MM-dd" clearable
            v-model="ruleForm.establish_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="所属行业" prop="industry">
          <el-select v-model="ruleForm.industry" filterable clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.industrys" :key="item.code" :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属产业" prop="industry_type">
          <el-select v-model="ruleForm.industry_type" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.cys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作状态" prop="cooperation_status">
          <el-select v-model="ruleForm.cooperation_status" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.cooperations" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作开始时间" prop="cooperation_start_date">
          <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd" clearable
            v-model="ruleForm.cooperation_start_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="合作结束时间" prop="cooperation_end_date">
          <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd" clearable
            v-model="ruleForm.cooperation_end_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="合作协议签署状态" prop="agreement_status">
          <el-select v-model="ruleForm.agreement_status" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.agreements" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', creatTrainBaseOut)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateTrainBaseOut)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrainBaseOut">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="`${$store.state.themeTitle}室打分`"
      :visible.sync="centerDialogVisible1" width="826px">
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" :rules="rules1" label-width="120px"
        class="demo-dynamic">
        <el-form-item label="年份期号" prop="year" style="width:100%;">
          <!-- <el-input v-model="dynamicValidateForm.year" placeholder="请输入年份期号" style="width:216px;"></el-input> -->
          <el-select v-model="dynamicValidateForm.year" style="width:216px;" placeholder="请选择年份期号">
            <el-option v-for="item in $store.state.years" :key="item.id" :label="item.year"
              :value="item.year"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="(domain, index) in dynamicValidateForm.items" :label="domain.item" :key="index">
          <el-input-number v-model="domain.score"></el-input-number>
          &nbsp;
          <el-button @click.prevent="removeDomain(domain)">删除</el-button>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button @click="addDomain">新增条目</el-button>
          <el-button type="primary" @click="submitForm1('dynamicValidateForm')">提交</el-button>
          <!-- <el-button @click="resetForm11('dynamicValidateForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinImport } from '@/assets/js/mixin/import';


export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinValidate, mixinImport],
  data() {

    return {
      centerDialogVisible1: false,
      dynamicValidateForm: {
        base_id: '',
        items: [],
        year: [],
      },
      years: [],
      currentYears: [],
      detailDialogVisible: false,
      tableData1: [],
      selectName: '',
      levell: [1, 2],
      levell1: [1],
      formInline: {
        name: '',
        structure_1: '',
        sign_agreement_date: '',
      },
      ruleForm: {
        name: '',
        major: '',
        structure_1: '',
        address: '',
        platform: '',
        sign_agreement_date: '',
        company_teacher: '',
        post: '',
        people_num: 0,
        teacher_id: '',
        last_grade_level: '',
        base_no: '',
        dwzzjgdm: '',
        rely_unit_name: '',
        rely_unit_type: '',
        on_job_staff_num: '',
        region: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        establish_date: '',
        industry: '',
        industry_type: '',
        cooperation_start_date: '',
        cooperation_end_date: '',
        agreement_status: '',
        cooperation_status: '正常',
        province_id: '',
        city_id: '',
        district_id: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入实训基地名称', trigger: 'blur' }],
        base_no: [{ required: true, message: '请输入', trigger: 'blur' }],
        dwzzjgdm: [{ required: true, message: '请输入', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        district_id: [
          { required: true, message: '请选择' , trigger: 'change'},
        ],
        structure_1: [
          { required: true, message: '请选择' , trigger: 'change'},
        ],
        cooperation_status: [
          { required: true, message: '请选择' , trigger: 'change'},
        ],
        // platform: [{ required: true, message: '请输入主要设备平台或工艺', trigger: 'blur' }],
        // sign_agreement_date: [{ required: true, message: '请选择协议签订时间', trigger: 'change' }],
        // company_teacher: [{ required: true, message: '请输入企业导师代表', trigger: 'blur' }],
        // post: [{ required: true, message: '请输入主要岗位', trigger: 'blur' }],
        people_num: [ { validator: this.checkInt, trigger: 'blur' }],
        contact_phone: [
          { validator: this.checkphone, trigger: 'blur' }
        ],
        // teacher_id: [{ required: true, message: '请选择', trigger: 'change' }],
        rely_unit_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        rely_unit_type: [{ required: true, message: '请选择' , trigger: 'change'},],
        on_job_staff_num: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        contact_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        contact_phone: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkphone, trigger: 'blur' }],
        establish_date: [{ required: true, message: '请选择' , trigger: 'change'},],
        industry_type: [{ required: true, message: '请选择' , trigger: 'change'},],
        cooperation_end_date: [{ required: true, message: '请选择' , trigger: 'change'},],
        cooperation_start_date: [{ required: true, message: '请选择' , trigger: 'change'},],
        industry: [{ required: true, message: '请选择' , trigger: 'change'},],
        agreement_status: [{ required: true, message: '请选择' , trigger: 'change'},],

        
      },
      rules1: { year: [{ required: true, message: '请输入年份期号', trigger: 'blur' }] },
      organDialogVisible: false,
      type: 'add',
      loading: false,
      users: [],
      downloadUrl: 'template/校外实训基地导入模版.xlsx',
      importUrl: '',
    };
  },
  created() {
    this.importUrl = `${this.baseUrlt}api/xmhy/training_base_out/import`;

  },
  mounted() {
    // this.getList();
    this.getTrainOutItems();
    // this.getYearItems();
    this.$store.dispatch("getTrainOutYearConfig")
    this.$store.dispatch("getIndustrys")
    // this.$store.dispatch("getProvices")
    // 
    // this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handlePositionChange(val, key) {
      this.ruleForm.district_id = ''
      if (key == 'city') {
        this.ruleForm.city_id = ''
        this.$store.dispatch("getCitys", { province_id: val })
      }
      if (key == 'district') {
        this.$store.dispatch("getDistricts", { city_id: val })
      }
    },
    handleScore(row) {
      this.dynamicValidateForm.base_id = row.id;
      this.centerDialogVisible1 = true;
    },
    handleCollaborate(id, collaborate) {
      let title = collaborate == 0 ? '是否确定设置不再合作!' : '是否确定设置合作!';
      this.confirmBox('warning', title, { id, collaborate }, this.updateCollaborate);
    },
    // async getYearItems() {
    //   let res = await this.$api.query.getTrainOutYearConfig();
    //   if (res.code == 0) {
    //     this.years = res.data;
    //   }
    // },
    async getTrainOutItems() {
      let res = await this.$api.query.getTrainOutConfig();
      if (res.code == 0) {
        this.dynamicValidateForm.items = res.data.map((item) => {
          return { item: item.item, score: item.score };
        });
      }
    },
    async updateCollaborate(params) {
      let res = await this.$api.update.updateCollaborate(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.handleQuery();
      }
    },
    handleEditInit(row) {
      this.$store.dispatch("getProvices")
      if (row.city_id) {
        this.$store.dispatch("getCitys", { province_id: row.province_id })
      }
      if (row.district_id) {
        this.$store.dispatch("getDistricts", { city_id: row.city_id })
      }
      if (row.teacher && (JSON.stringify(this.users).indexOf(row.teacher_id) == -1)) {
        this.users.push({ id: row.teacher_id, name: row.teacher, number: row.teacher_number })
      }
      this.handleEditCallBackSetStruc({ row })
    },
    handleEdit(row, filterArr = ['scoreList', 'created_at', 'updated_at', 'deleted_at', 'creator_id', 'tts']) {
      this.selectName = row.structure_1 + row.major;
      this.type = 'edit';
      this.title = '编辑';
      this.remoteMethod('', row.teacher_number);
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.centerDialogVisible = true;
    },
    async remoteMethod(query, number) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        number,
        type: this.$until.getPostsType([4])
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
      }
      this.loading = false;
    },
    handleTeacherChange(val) {
      this.ruleForm.teacher = this.$until.getLabelName(this.users, 'id', 'name', val);
      this.ruleForm.teacher_number = this.$until.getLabelName(this.users, 'id', 'number', val);
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },

    addDomain() {
      // this.dynamicValidateForm.domains.push( { item: '实验报告', score: 0 });
      this.$prompt('请输入条目', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // this.$message({
          //   type: 'success',
          //   message: '你的邮箱是: ' + value
          // });
          this.dynamicValidateForm.items.push({ item: value, score: 0 });
        })
        .catch(() => { });
    },
    removeDomain(item) {
      console.log(item);
      var index = this.dynamicValidateForm.items.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.items.splice(index, 1);
      }
    },
    submitForm1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.baseScoreAdd();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async baseScoreAdd() {
      let params = {
        base_id: this.dynamicValidateForm.base_id,
        year: this.dynamicValidateForm.year,
        items: JSON.stringify(this.dynamicValidateForm.items),
      };
      let res = await this.$api.update.baseScoreAdd(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '打分成功！',
        });
        this.centerDialogVisible1 = false;
        this.handleQuery();
      }
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },

    getOrganList() {
      this.beforeGetOrgan({ limit: false })
    },
    async deleteTrainBaseOut() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteTrainBaseOut(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatTrainBaseOut() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.creatTrainBaseOut(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTrainBaseOut() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateTrainBaseOut(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      if (this.selectNodeForQuery.level == 1) {
        this.formInline.structure_1 = this.selectNodeForQuery.structure_names;
      } else {
        this.formInline.structure_1 = '';
      }
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getTrainBaseOut(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
